import React, { useState } from 'react';

import { TextField } from '@material-ui/core';

import DialogDefault from '../common/DialogDefault';

const ModalRename = ({
	openRenameModal,
	renameSelectedTableComponent,
	optionsMenueClickable,
	headline,
	toggleRenameModal,
}) => {
	const [inputRenameValue, setInputRenameValue] = useState();

	const submitData = (e) => {
		e.preventDefault();
		toggleRenameModal();
		renameSelectedTableComponent(inputRenameValue);
	};

	return (
		<DialogDefault
			headline={headline}
			openModal={openRenameModal}
			closeModal={toggleRenameModal}
			confirmButton={(e) => submitData(e)}
			maxWidth="lg"
		>
			<form autoComplete="off" onSubmit={(e) => submitData(e)}>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label={optionsMenueClickable.inputRenameLabel}
					inputProps={{
						maxLength: 20,
					}}
					onInput={(e) => setInputRenameValue(e.target.value)}
				/>
			</form>
		</DialogDefault>
	);
};

export default ModalRename;
